module.exports = __webpack_public_path__ + "img/capacitor-green.76a6d96c.webp";